import React, { useEffect, useState } from "react";
import {
    ALL_APPOINTMENT_STATUS,
    APPOINTMENT_STATUS,
    APPOINTMENT_ZONE,
    APPOINTMENT_ZONE_DOCTOR,
    decideStatus,
    LOADER_TIMEOUT_TIME,
    ROLE,
    SORT_A,
    SORT_D,
    SWAL_SETTINGS,
} from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
    capitalizeFirstLetter,
    extractTime,
    formatDateNew,
    formateDate,
    getUser,
    handleOffcanvasScroll,
    handleServerValidations,
    removeSpecialCharacter,
    TrimText,
    useDebouncing,
} from "../../../../utils/commonfunction";
import CustomError from "../../../../utils/customError";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import RecordNotFound from "../../shared/recordNotFound";
import { DatePicker, Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../admin/common/custompagination";
import { addAppointments, editAppointments, getAppointments, listAppointments } from "../../services/patient.services";
import { useValidationSchemas } from "../../../center/validator/validation";

export default function PatientAppointment() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const { t } = useTranslation();
    const [List, setList] = useState([]);
    const { appointmentDoctorValidationSchema, editAppointmentDoctorValidationSchema } = useValidationSchemas();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
    const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
    const [globalSearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({});
    const [loader, setLoader] = useState(true);
    const [scheduleDetail, setScheduleDetail] = useState({});
    const [page, setPage] = useState(1);
    const [offset, setOffsetPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage] = useState(10);
    const [sortConfig, setSortConfig] = useState({ column: "appointment_date", order: SORT_D });
    const [sortHistoryConfig, setSortHistoryConfig] = useState({ column: "date", order: SORT_D });
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
    const [searchParams] = useSearchParams();
    const patientData = searchParams?.get("patient_id");
    const [doctorData, setDoctorData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const patientId = params?.patientId;

    const handleSort = (key) => {
        let direction = SORT_A;
        if (sortConfig.column === key && sortConfig.order === SORT_A) {
            direction = SORT_D;
        }
        setSortConfig({ column: key, order: direction });
    };

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        searchDebounce(value);
    };

    const prepareGlobalSearch = (value) => {
        setPrevGlobalSearch(globalSearch);
        setGlobalSearch(value);
    };
    const searchDebounce = useDebouncing(prepareGlobalSearch);

    const handleFilterStatusChange = (e) => {
        if (e.target.value) {
            prepareSearch("status", Number(e.target.value));
        } else {
            prepareSearch("status", "");
        }
    };

    // Handle select dropdown change
    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        handleFilterStatusChange(e);
        prepareSearch("status", value);
    };

    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        let page = params.page;
        if (globalSearch) {
            if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
                page = 1;
            }
            setPage(page);
        }
        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        if (sortConfig) {
            formData.append("sort", JSON.stringify(sortConfig));
        }
        formData.append("patient_id", patientId);
        listAppointments(formData)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    console.log("api hitting");
                    // navigate(`/center/patient/appointment/${data.data.page}?patient_id=${patientData}`);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setPrevGlobalSearch(globalSearch);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig]);

    const getAppointmentDetail = (item) => {
        const formData = new FormData();
        formData.append("appointment_id", item?._id);
        getAppointments(formData)
            .then((response) => {
                const appointment_date = new Date(response?.data?.appointment_date);
                const year = appointment_date.getFullYear();
                const month = String(appointment_date.getMonth() + 1).padStart(2, "0");
                const date = String(appointment_date.getDate()).padStart(2, "0");
                const formattedDate = `${year}-${month}-${date}`;

                const hours = String(appointment_date.getHours()).padStart(2, "0");
                const mins = String(appointment_date.getMinutes()).padStart(2, "0");
                const formattedTime = `${hours}:${mins}:00`;

                editForm.setValues({
                    appointment_id: response?.data?._id || "",
                    major_concern: response?.data?.major_concern || "",
                    appointment_zone: response?.data?.appointment_zone || "",
                    doctor_id: response?.data?.doctor_id || "",
                    status: response?.data?.status || "",
                    // appointment_date: response?.data?.appointment_date || "",
                    // start_time: response?.data?.start_time || "",
                    appointment_date: formattedDate || "",
                    start_time: formattedTime || "",
                });
                setScheduleDetail(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    console.log("patientId-******->", patientId);

    const addForm = useFormik({
        initialValues: {
            doctor_id: "",
            major_concern: "",
            appointment_zone: "",
            appointment_date: "",
            start_time: "",
        },
        validationSchema: appointmentDoctorValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("patient_id", patientId);
            // formData.append("patient_id", patientData);
            // formData.append("doctor_id", values?.doctor_id);
            formData.append("major_concern", values?.major_concern);
            formData.append("appointment_zone", values?.appointment_zone);

            const appointment_date = new Date(values?.appointment_date);
            const [hours, mins] = values?.start_time.split(":").map((ele) => +ele);
            appointment_date.setHours(hours, mins);
            formData.append("appointment_date", appointment_date);

            // formData.append("appointment_date", values?.appointment_date);
            // formData.append("start_time", values?.start_time);
            setAddSubmissionLoader(true);
            addAppointments(formData)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeader(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });

    const editForm = useFormik({
        initialValues: {
            appointment_id: "",
            doctor_id: "",
            major_concern: "",
            appointment_zone: "",
            status: "",
            appointment_date: "",
            start_time: "",
        },
        validationSchema: editAppointmentDoctorValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            setEditSubmissionLoader(true);
            const formData = new FormData();
            formData.append("appointment_id", scheduleDetail._id);
            formData.append("patient_id", patientId);
            // formData.append("patient_id", patientData);
            // formData.append("doctor_id", values?.doctor_id);
            formData.append("major_concern", values?.major_concern);
            formData.append("appointment_zone", values?.appointment_zone);
            formData.append("status", values?.status);

            const appointment_date = new Date(values?.appointment_date);
            const [hours, mins] = values?.start_time.split(":").map((ele) => +ele);
            appointment_date.setHours(hours, mins);
            formData.append("appointment_date", appointment_date);
            // formData.append("appointment_date", values?.appointment_date);
            // formData.append("start_time", values?.start_time);
            editAppointments(formData)
                .then((response) => {
                    setEditSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeaderEdit(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setEditSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });

    // useEffect(() => {
    //     const centerData = localStorage.getItem("center")
    //     const parsedCenter = JSON.parse(centerData);
    //     const formData = new FormData();
    //     formData.append("center_id", parsedCenter?._id)
    //     allDoctors(formData)
    //         .then((data) => {
    //             if (data && data.data) {
    //                 setDoctorData(data?.data || []);
    //             }
    //         })
    //         .catch((error) => {
    //             console.log("error ====> ", error);
    //         });
    // }, [])

    const getDateWithTime = (timeValue) => {
        if (!timeValue) return null;
        const [hours, minutes, seconds] = timeValue.split(":");
        const date = new Date();
        date.setHours(hours, minutes, seconds || "00");
        return date;
    };

    const handleStartTimeChange = (e) => {
        addForm.setFieldTouched("start_time", true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(":");
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || "00";
            addForm.setFieldValue("start_time", `${hours}:${minutes}:${seconds}`);
        }
    };

    // Utility function
    function parseLocalDate(dateStr) {
        if (!dateStr) return null;
        const [year, month, day] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day); // local midnight IST
    }
    console.log("params-->", params);

    return (
        <main id="main-content">
            <div className="inner-container">
                <div className="page-header d-flex align-items-center">{/* <h4 className="heading-title-text">{t("Schedule Management")}</h4> */}</div>
                <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
                    <div className="search-box">
                        <input type="text" value={searchValue} className="form-control search-input" placeholder={t("center.staff.input_placeholder_search")} onChange={handleSearchChange} />
                    </div>
                    <div className="card-head-group d-flex align-items-center gap-2">
                        <div className="tabls-dowpdown">
                            <select className="form-control cp" value={selectedStatus} onChange={handleSelectChange}>
                                <option disabled="" value="">
                                    {t("center.staff.label_select_status")}
                                </option>
                                {ALL_APPOINTMENT_STATUS?.map((status) => {
                                    return (
                                        <option key={status?.value} value={status?.value}>
                                            {status?.label}
                                        </option>
                                    );
                                })}
                                {/* <option value="schedule">Schedule</option>
                                <option value="reschedule">Reschedule</option>
                                <option value="completed">Completed</option> */}
                            </select>
                        </div>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                setOpenWithHeader(true);
                            }}
                        >
                            {t("Add New Appointment")}
                        </button>
                    </div>
                </div>

                <div className="dashboard-content-wraper">
                    <div className="category-list-wrap">
                        <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>S. No.</th>
                                                <th>
                                                    {t("Doctor Name")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("doctor_id")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "doctor_id" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "doctor_id" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    {t("Patient Name")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("patient_name")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "patient_name" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "patient_name" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    {t("Appointment Date")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("appointment_date")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "appointment_date" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "appointment_date" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    {t("Appointment Time")}
                                                    <span
                                                        style={{ cursor: "pointer" }}
                                                        // onClick={() => handleSort('appointment_date')}
                                                    >
                                                        {/* <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'appointment_date' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '5px' }}></i>
                                                            <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'appointment_date' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                                style={{ marginLeft: '-8px' }} /> */}
                                                    </span>
                                                </th>
                                                <th>Status</th>
                                                <th style={{ width: "150px" }}>{t("center.staff.label_action")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loader ? (
                                                <td colSpan={8}>
                                                    <Skeleton className="mb-2" height={50} count={5} />
                                                </td>
                                            ) : List?.length ? (
                                                List.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{offset + index + 1}</td>
                                                            <td>{capitalizeFirstLetter(item?.doctor_name)}</td>
                                                            <td>{capitalizeFirstLetter(item?.patient_name)}</td>
                                                            {/* <td>{formatDateNew(item?.appointment_date)}</td>
                                                            <td>{item?.appointment_date?.slice(11, 16)}</td> */}
                                                            <td>{formateDate(item?.appointment_date)}</td>
                                                            <td>{extractTime(item?.appointment_date)}</td>
                                                            <td>{decideStatus(item?.status)}</td>
                                                            <td className="">
                                                                <div className="dropdown ms-2">
                                                                    <button
                                                                        className="btn btn-icon dropdown-toggle"
                                                                        type="button"
                                                                        id="dropdownMenuButton"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="ti ti-dots-vertical"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    getAppointmentDetail(item);
                                                                                }}
                                                                                data-bs-toggle="offcanvas"
                                                                                data-bs-target="#view-staff"
                                                                            >
                                                                                <i className="ti ti-eye"></i>
                                                                                {t("center.button.btn_view")}
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    getAppointmentDetail(item);
                                                                                    setOpenWithHeaderEdit(true);
                                                                                }}
                                                                            >
                                                                                <i className="ti ti-edit"></i>
                                                                                {t("center.button.btn_edit")}
                                                                            </a>
                                                                        </li>
                                                                        {item?.status !== "canceled" && (
                                                                            <li>
                                                                                <Link className="dropdown-item cp" to={`/doctor/consultation-history/view/${item?._id}`}>
                                                                                    <i className="fas fa-prescription-bottle-alt"></i>
                                                                                    Create Prescription
                                                                                </Link>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="9">
                                                        <RecordNotFound heading="center.staff.no_staff_found" />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-status-info d-flex justify-content-between align-items-center">
                                    <span>
                                        {t("center.staff.label_showing")} {offset + List.length} of {totalRecords} {t("center.staff.label_entries")}
                                    </span>
                                    <nav aria-label="Page navigation example" title={page}>
                                        {totalRecords && totalRecords > 0 ? (
                                            <CustomPagination
                                                datalength={totalRecords}
                                                itemperpage={itemPerPage}
                                                currentPage={page}
                                                custompath="page"
                                                setPage={setPage}
                                                pageRoute={[{ name: "settings", path: `/doctor/patient/appointment/${patientId}` }]}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>

            {/* add item modal  */}
            <Drawer open={openWithHeader}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Create Appointment")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeader(false);
                                addForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editNewEmail", "rsuite");
                    }}
                >
                    <form onSubmit={addForm.handleSubmit}>
                        {/* <div className="mb-3">
                            <label className="form-label">{t("Select Doctor")}<span>*</span></label>
                            <select className="form-control cp" name='doctor_id' value={addForm?.values?.doctor_id} onChange={addForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {doctorData?.map((item, index) => (
                                    <option key={index} value={item._id}>
                                        {capitalizeFirstLetter(item.name)}
                                    </option>
                                ))}
                            </select>
                            {addForm.touched.doctor_id && addForm.errors.doctor_id ? (
                                <div className="text-danger">{t(addForm.errors.doctor_id)}</div>
                            ) : null}
                        </div> */}

                        <div className="mb-3">
                            <label className="form-label">
                                {t("Appointment Date")}
                                <span>*</span>
                            </label>
                            <DatePicker
                                oneTap={true}
                                classPrefix="restaurant"
                                placeholder={t("Enter date")}
                                placement="autoVertical"
                                format="dd.MM.yyyy"
                                cleanable={false}
                                name="appointment_date"
                                onChange={(e) => {
                                    // addForm.setFieldTouched('appointment_date', true);
                                    // const formattedDate = e.toISOString().split('T')[0];

                                    const year = e.getFullYear();
                                    const month = String(e.getMonth() + 1).padStart(2, "0");
                                    const date = String(e.getDate()).padStart(2, "0");

                                    addForm.setFieldTouched("appointment_date", true);
                                    const formattedDate = `${year}-${month}-${date}`;

                                    addForm.setFieldValue("appointment_date", formattedDate);
                                    // addForm.setFieldValue("appointment_date", e);
                                }}
                                // value={new Date(addForm.values.appointment_date)}
                                value={new Date(addForm.values.appointment_date)}
                                onBlur={addForm.handleBlur}
                                shouldDisableDate={(date) => {
                                    const currentDate = new Date();
                                    currentDate.setHours(0, 0, 0, 0);
                                    return date < currentDate;
                                }}
                            />
                            <CustomError name="appointment_date" form={addForm} className="text-danger" />
                        </div>

                        {/* <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Start Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            name="start_time"
                                            onChange={handleStartTimeChange}
                                            value={getDateWithTime(addForm.values.start_time)}
                                            onBlur={addForm.handleBlur}
                                        />
                                        <CustomError name="start_time" form={addForm} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12"></div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Start Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={false}
                                            name="start_time"
                                            onChange={handleStartTimeChange}
                                            value={getDateWithTime(addForm.values.start_time)}
                                            onBlur={addForm.handleBlur}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                        />
                                        <CustomError name="start_time" form={addForm} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                {t("Major Concern")}
                                <span>*</span>
                            </label>
                            <textarea
                                type="text"
                                className="form-control"
                                placeholder={t("Enter major concern")}
                                name="major_concern"
                                value={addForm?.values?.major_concern}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="major_concern" form={addForm} className="text-danger" />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t("Appointment Zone")}</label>
                            <select className="form-control form-select cp" name="appointment_zone" value={addForm?.values?.appointment_zone} onChange={addForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {APPOINTMENT_ZONE_DOCTOR.map((item) => (
                                    <option key={item.value} value={item.value}>
                                        {capitalizeFirstLetter(item.label)}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                                Create
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            <Drawer open={openWithHeaderEdit}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Edit Appointment")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeaderEdit(false);
                                editForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editEmail", "rsuite");
                    }}
                >
                    <form onSubmit={editForm.handleSubmit}>
                        {/* <div className="mb-3">
                            <label className="form-label">{t("Select Doctor")}<span>*</span></label>
                            <select className="form-control cp" name='doctor_id' value={editForm?.values?.doctor_id} onChange={editForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {doctorData?.map((item, index) => (
                                    <option key={index} value={item._id}>
                                        {capitalizeFirstLetter(item.name)}
                                    </option>
                                ))}
                            </select>
                            {editForm.touched.doctor_id && editForm.errors.doctor_id ? (
                                <div className="text-danger">{t(editForm.errors.doctor_id)}</div>
                            ) : null}
                        </div> */}

                        <div className="mb-3">
                            <label className="form-label">
                                {t("Appointment Date")}
                                <span>*</span>
                            </label>
                            <DatePicker
                                oneTap={true}
                                classPrefix="restaurant"
                                placeholder={t("Enter date")}
                                placement="autoVertical"
                                format="dd.MM.yyyy"
                                cleanable={false}
                                name="appointment_date"
                                // onChange={(e) => {
                                //     editForm.setFieldTouched('appointment_date', true);
                                //     editForm.setFieldValue("appointment_date", e);
                                // }}
                                onChange={(e) => {
                                    // const formattedDate = e.toISOString().split('T')[0];
                                    // editForm.setFieldValue("appointment_date", formattedDate);

                                    // editForm.setFieldTouched('appointment_date', true);
                                    // editForm.setFieldValue("appointment_date", e);

                                    const year = e.getFullYear();
                                    const month = String(e.getMonth() + 1).padStart(2, "0");
                                    const date = String(e.getDate()).padStart(2, "0");

                                    editForm.setFieldTouched("appointment_date", true);
                                    const formattedDate = `${year}-${month}-${date}`;
                                    editForm.setFieldValue("appointment_date", formattedDate);
                                }}
                                value={new Date(editForm.values.appointment_date)}
                                onBlur={editForm.handleBlur}
                                shouldDisableDate={(date) => {
                                    const currentDate = new Date();
                                    currentDate.setHours(0, 0, 0, 0);
                                    return date < currentDate;
                                }}
                            />
                            <CustomError name="appointment_date" form={editForm} className="text-danger" />
                        </div>

                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12"></div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Start Time <span>*</span>
                                    </label>
                                    <div className="mb-3">
                                        <DatePicker
                                            classPrefix="restaurant"
                                            placement="autoVertical"
                                            format="HH:mm"
                                            cleanable={false}
                                            editable={true}
                                            hideMinutes={(minute) => minute % 15 !== 0}
                                            name="start_time"
                                            onChange={(e) => {
                                                editForm.setFieldTouched("start_time", true);
                                                const match = String(e).match(/\d{2}:\d{2}:\d{2}/);
                                                if (match) {
                                                    const [hours, minutes] = match[0].split(":");
                                                    editForm.setFieldValue("start_time", `${hours}:${minutes}:00`);
                                                }
                                            }}
                                            value={getDateWithTime(editForm.values.start_time)}
                                            onBlur={editForm.handleBlur}
                                        />
                                        <CustomError name="start_time" form={editForm} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                {t("Major Concern")}
                                <span>*</span>
                            </label>
                            <textarea
                                type="text"
                                className="form-control"
                                placeholder={t("Enter major concern")}
                                name="major_concern"
                                value={editForm?.values?.major_concern}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            <CustomError name="major_concern" form={editForm} className="text-danger" />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t("Appointment Zone")}</label>
                            <select className="form-control form-select cp" name="appointment_zone" value={editForm?.values?.appointment_zone} onChange={editForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {APPOINTMENT_ZONE_DOCTOR.map((item) => (
                                    <option key={item.value} value={item.value}>
                                        {capitalizeFirstLetter(item.label)}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                {t("Status")}
                                <span>*</span>
                            </label>
                            <select className="form-control cp" name="status" value={editForm?.values?.status} onChange={editForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {APPOINTMENT_STATUS.map((item, index) => {
                                    return (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    );
                                })}
                            </select>
                            {editForm.touched.status && editForm.errors.status ? <div className="text-danger">{t(editForm.errors.status)}</div> : null}
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                                Update
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View Appointment
                    </h3>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="view-staff-info">
                        <div className="row gap-4">
                            <div className="col-md-12">
                                <h4>{t("Appointment ID")}</h4>
                                <p>#{scheduleDetail?.appointment_register_id}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Patient ID")}</h4>
                                <p>#{scheduleDetail?.patient_register_id}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Doctor Name")}</h4>
                                <p>{capitalizeFirstLetter(scheduleDetail?.doctor_name)}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Patient Name")}</h4>
                                <p>{capitalizeFirstLetter(scheduleDetail?.patient_name)}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Status")}</h4>
                                <p>{capitalizeFirstLetter(scheduleDetail.status)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Appointment Date")}</h4>
                                <p>{formateDate(scheduleDetail.appointment_date)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Appointment Time")}</h4>
                                <p>{extractTime(scheduleDetail.appointment_date)} </p>

                                {/* <p>{scheduleDetail?.appointment_date?.slice(11, 16)} </p> */}
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Major Concern")}</h4>
                                <p>{capitalizeFirstLetter(scheduleDetail.major_concern)} </p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("Appointment Zone")}</h4>
                                <p>
                                    {
                                        scheduleDetail?.appointment_zone
                                        ? capitalizeFirstLetter(removeSpecialCharacter(scheduleDetail.appointment_zone))
                                        : "N/A"
                                    } 
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
